import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from 'src/components/widgets/loader';
import { FullscreenLayout } from 'src/components/widgets/fullscreenIframeLayout';
import { backofficeUrl, toLocalID } from 'src/shared/helpers';
import styled from 'styled-components';
import { useProductConfigurationState } from '../../state';

const Redirecting = styled(FullscreenLayout)`
    align-items: center;
    justify-content: center;
    background: #f6f8f9;
`;

/**
 * Compatibility redirect for old bookmarks and persisted product-step URLs.
 * Configurator preview is the product-level Testing Mode; it must not maintain a second embedded flow.
 */
const ShoppingPreview = () => {
    const navigate = useNavigate();
    const { state } = useProductConfigurationState();
    const productID = toLocalID(state.product.id);

    useEffect(() => {
        navigate(backofficeUrl(productID != null ? `/test-mode/${productID}` : '/products'), { replace: true });
    }, [navigate, productID]);

    return (
        <Redirecting role='status' aria-label='Opening Testing Mode'>
            <Loader />
        </Redirecting>
    );
};

export default ShoppingPreview;
